import React from 'react';
import ErrorOverlay from '../components/01_atoms/ErrorOverlay';
import PropTypes from 'prop-types';

const ErrorPage = (props) => {
  if (props.app === 'gifts') {
    import('../styles/gifts/sass/theme.scss');
  } else {
    import('../styles/styles.scss');
  }

  return (
    <div className="error-page">
      <ErrorOverlay {...props} />
    </div>
  );
};

// Opt-out of Automatic Static Optimization.
// See https://nextjs.org/docs/api-reference/next.config.js/runtime-configuration
ErrorPage.getInitialProps = async () => {};

ErrorPage.propTypes = {
  app: PropTypes.string.isRequired,
};

export default ErrorPage;
